export default "__VITE_ASSET__Bclq$hrH__"